module.exports = __webpack_public_path__ + "assets/img/siri.ffa907ca.png";